import React from "react";
import TransportationNotifications from "../../transportationNotifications/transportationNotifications";

function OrderNotifications() :JSX.Element {
    return (
        <div className="transportation-order-notifications">
            <TransportationNotifications
                element="order"
            />
        </div>
    );
}

export default OrderNotifications;
